const { languages, defaultLanguage } = require('../../locales');

function isDefaultLanguage(languageId) {
  return languageId === defaultLanguage.id;
}

function getLocaleFlag(locale) {
  return languages.find(({ id }) => id === locale).flag;
}

module.exports = {
  isDefaultLanguage,
  getLocaleFlag,
};
